var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionOpenLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3128 3.29289C9.92226 3.68342 9.92226 4.31658 10.3128 4.70711L12.5914 6.98577L10.2929 9.28432C9.90237 9.67484 9.90237 10.308 10.2929 10.6985C10.6834 11.0891 11.3166 11.0891 11.7071 10.6985L14.7134 7.69223C15.1039 7.3017 15.1039 6.66854 14.7134 6.27802C14.7032 6.26782 14.6929 6.2579 14.6824 6.24824L11.727 3.29289C11.3365 2.90237 10.7033 2.90237 10.3128 3.29289Z",
    fill: "#222222",
    fillOpacity: 0.65
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.68721 3.29289C6.07774 3.68342 6.07774 4.31658 5.68721 4.70711L3.40855 6.98577L5.70711 9.28432C6.09763 9.67484 6.09763 10.308 5.70711 10.6985C5.31658 11.0891 4.68342 11.0891 4.29289 10.6985L1.28659 7.69223C0.896066 7.3017 0.896066 6.66854 1.28659 6.27802C1.29678 6.26782 1.30714 6.2579 1.31765 6.24824L4.273 3.29289C4.66352 2.90237 5.29669 2.90237 5.68721 3.29289Z",
    fill: "#222222",
    fillOpacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionOpenLight);
export default __webpack_public_path__ + "static/media/action-open-light.afacf2652f3fc7afba36c889f6d61a4a.svg";
export { ForwardRef as ReactComponent };